const SALESFORCE_ENDPOINTS = {
    AU: {
        locales: {
            en: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2021-04-12/v65`,
                    "action_cu_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-24/2rlb`,
                    "action_new_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-23/2rkj`,
                    "action_rental_form": `https://go.demo.pardot.com/l/889881/2024-07-29/2s1t`,
                    "action_rental_finance_form": `https://go.demo.pardot.com/l/889881/2024-07-29/2s1t`,
                    "action_application_form_url": `https://go.demo.pardot.com/l/889881/2025-02-13/37fg?country=Australia&lead_category=Application&process_web_application=true&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.com.au/l/212762/2016-07-18/x5`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.com.au/l/212762/2023-08-01/3k7nvm`,
                    "action_new_enquire_endpoint": `https://go.silverchef.com.au/l/212762/2024-06-12/3lsl1t`,
                    "action_rental_form": `https://go.silverchef.com.au/l/212762/2016-07-20/213i`,
                    "action_rental_finance_form": `https://go.silverchef.com.au/l/212762/2022-07-06/3cj4my`,
                    "action_application_form_url": `https://go.silverchef.com.au/l/212762/2019-01-02/2125p8?country=Australia&lead_category=Application&process_web_application=true&`,
                },
            },
        }
    },
    NZ: {
        locales: {
            en: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2022-03-01/289h`,
                    "action_cu_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-24/2rlf`,
                    "action_new_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-24/2rl7`,
                    "action_rental_form": `https://go.demo.pardot.com/l/889881/2024-07-29/2s21`,
                    "action_rental_finance_form": `https://go.demo.pardot.com/l/889881/2024-07-29/2s21`,
                    "action_application_form_url": `https://go.demo.pardot.com/l/889881/2025-02-14/37fk?country=New%20Zealand&lead_category=Application&process_web_application=true&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.co.nz/l/212762/2019-01-03/212b76`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.co.nz/l/212762/2023-08-22/3kdw4y`,
                    "action_new_enquire_endpoint": `https://go.silverchef.co.nz/l/212762/2024-06-12/3lsl4j`,
                    "action_rental_form": `https://go.silverchef.co.nz/l/212762/2019-01-04/212bnz`,
                    "action_rental_finance_form": `https://go.silverchef.co.nz/l/212762/2019-01-04/212bnz`,
                    "action_application_form_url": `https://go.silverchef.co.nz/l/212762/2019-01-02/2125qq?country=New%20Zealand&lead_category=Application&process_web_application=true&`,
                },
            },
        }
    },
    CA: {
        locales: {
            en: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2022-01-25/27yc`,
                    "action_cu_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-24/2rlj`,
                    "action_new_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-24/2rl1`,
                    "action_rental_form": `https://go.demo.pardot.com/l/889881/2024-07-29/2s24`,
                    "action_rental_finance_form": `	https://go.demo.pardot.com/l/889881/2024-07-29/2s24`,
                    "action_application_form_url": `https://go.demo.pardot.com/l/889881/2025-02-14/37fn?country=Canada&lead_category=Application&process_web_application=true&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.ca/l/212762/2019-01-03/212b78`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.ca/l/212762/2023-08-22/3kdw4v`,
                    "action_new_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl4m`,
                    "action_rental_form": `https://go.silverchef.ca/l/212762/2019-01-04/212bnl`,
                    "action_rental_finance_form": `https://go.silverchef.ca/l/212762/2019-01-04/212bnl`,
                    "action_application_form_url": `https://go.silverchef.ca/l/212762/2019-01-02/2125rl?country=Canada&lead_category=Application&process_web_application=true&`,
                },
            },
            fr: {
                development: {
                    "action_contact_url": `https://go.demo.pardot.com/l/247632/2022-01-25/27yf`,
                    "action_cu_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-24/2rlm`,
                    "action_new_enquire_endpoint": `https://go.demo.pardot.com/l/889881/2024-07-24/2rkx`,
                    "action_rental_form": `https://go.demo.pardot.com/l/889881/2024-07-29/2s27`,
                    "action_rental_finance_form": `https://go.demo.pardot.com/l/889881/2024-07-29/2s27`,
                    "action_application_form_url": `https://go.demo.pardot.com/l/889881/2025-02-14/37fr?country=Canada&lead_category=Application&process_web_application=true&language=FR&`,
                },
                production: {
                    "action_contact_url": `https://go.silverchef.ca/l/212762/2020-06-18/2j282n`,
                    "action_cu_enquire_endpoint": `https://go.silverchef.ca/l/212762/2023-09-06/3klbjy`,
                    "action_new_enquire_endpoint": `https://go.silverchef.ca/l/212762/2024-06-12/3lsl4q`,
                    "action_rental_form": `https://go.silverchef.ca/l/212762/2020-07-02/2j7j86`,
                    "action_rental_finance_form": `https://go.silverchef.ca/l/212762/2020-07-02/2j7j86`,
                    "action_application_form_url": `https://go.silverchef.ca/l/212762/2020-07-02/2j7jgv?country=Canada&lead_category=Application&process_web_application=true&language=FR&`,
                },
            }
        }
    },
}

export {SALESFORCE_ENDPOINTS}
